import React from 'react';
import { BaseLayout } from '../layout/BaseLayout';
import { ConfigLayout } from '../layout/ConfigLayout';

export type LayoutType = 'BaseLayout' | 'ConfigLayout';
type LayoutWrapperProps = {
  layoutType?: LayoutType;
  children: React.ReactNode;
  flexibleWidth?: boolean;
};

export const LayoutWrapper = ({ layoutType = 'BaseLayout', children, flexibleWidth = false }: LayoutWrapperProps) => {
  switch (layoutType) {
    case 'ConfigLayout':
      return <ConfigLayout flexibleWidth={flexibleWidth}>{children}</ConfigLayout>;
    case 'BaseLayout':
      return <BaseLayout flexibleWidth={flexibleWidth}>{children}</BaseLayout>;
    default:
      return <BaseLayout flexibleWidth={flexibleWidth}>{children}</BaseLayout>;
  }
};
